/**
 * Gates a route behind a Keycloak session. Unauthenticated users get
 * kicked to the Keycloak login (not a local form — we don't own
 * credentials).
 *
 * Under `VITE_E2E_MODE=true` there is no Keycloak — the route just
 * passes through (the bearer lives in localStorage, and relay-api
 * validates it against the e2e JWKS fixture).
 */

import { useKeycloak } from '@/auth/KeycloakProvider';
import { useEffect, type ReactNode } from 'react';

const E2E_MODE = import.meta.env.VITE_E2E_MODE === 'true';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  return E2E_MODE ? <>{children}</> : <KeycloakGate>{children}</KeycloakGate>;
}

function KeycloakGate({ children }: { children: ReactNode }) {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized && !keycloak.authenticated) {
      keycloak.login();
    }
  }, [initialized, keycloak]);

  if (!initialized || !keycloak.authenticated) {
    return null;
  }
  return <>{children}</>;
}
